export const getApiErrorMessage = (error, defaultMessage = "An unexpected error occurred.") => {
  const message = error?.response?.data?.message || error?.message || defaultMessage;
  const lowerMessage = message.toLowerCase();
  
  if (lowerMessage.includes("network error") || error?.message === "Network Error") {
    return "Network error. Please check your internet connection.";
  }
  if (lowerMessage.includes("timeout") || error?.code === "ECONNABORTED") {
    return "The request timed out. Please try again.";
  }

  const status = error?.response?.status;
  if (status === 401 || status === 403) {
    return "You do not have permission to perform this action.";
  }
  if (status === 404) {
    return "The requested resource could not be found.";
  }
  if (status >= 500) {
    return "An internal server error occurred. Please try again later.";
  }

  return message;
};
